<span class="topDetails">Request Details</span>
<div fxLayout="row wrap" fxFlex="100" class="portLocation">
    <logzy-view-data-field label="Equipment" fxFlex="91" [list]="requestService.selectedRequest?.requirement"
        [displayField]="'quantity'" [displayField1]="'container_size_type'" [displayField2]="'display'"
        [displayField3]="'condition'" [displayField4]="'value'" [space1]="'*'" [space2]="'('" [space3]="')'"
        fxLayout="column" class="align-items-center"></logzy-view-data-field>
    <app-mat-auto-search [label]="superLocationSourceLabel" [(ngModel)]="requestObj.pols"
        [(errors)]="requestObj.error.pols" [isEditable]="false" [idField]="null" displayField='name_display'
         [multiple]="true" [defaultChip]="false" [clearable]="true" [closeOnSelect]="false"
        [listUrl]="portUrl" name="pols" fxFlex="12em" class="example-full-width" [class.fx91]="modelService.selectedRequest?.request_type?.dev_name=='buy_sell'">
    </app-mat-auto-search>
    <ng-container *ngIf="!(modelService.selectedRequest?.request_type?.dev_name=='buy_sell')">
        <app-mat-auto-search [label]="superLocationDestinationLabel" [(ngModel)]="requestObj.pods"
            [(errors)]="requestObj.error.pods" [isEditable]="false" [idField]="null" displayField='name_display'
            [multiple]="true" [defaultChip]="false" [clearable]="true" [closeOnSelect]="false"
            [listUrl]="portUrl" name="pods" fxFlex="12em" class="example-full-width">
        </app-mat-auto-search>
    </ng-container>
    <ng-container *ngIf="modelService.selectedRequest?.request_type?.dev_name!='lease'">
        <logzy-view-data-field label="Requestor Company" [name]="requestService.selectedRequest" fxFlex="12em"
            [displayField]="'requestor'" [displayField1]="'company'" [displayField2]="'name'" fxLayout="column"
            class="align-items-center"></logzy-view-data-field>
        <logzy-view-data-field label="Requestor Name" [name]="requestService.selectedRequest"
            [displayField]="'requestor'" fxFlex="12em" [displayField1]="'first_name'" [displayField2]="'last_name'"
            fxLayout="column" class="align-items-center"></logzy-view-data-field>
        <logzy-view-data-field label="Requestor Email" [name]="requestService.selectedRequest"
            [displayField]="'requestor'" fxFlex="91" [displayField1]="'email'" fxLayout="column"
            class="align-items-center"></logzy-view-data-field>
    </ng-container>
    <ng-container *ngIf="modelService.selectedRequest?.request_type?.dev_name=='lease'">
        <logzy-view-data-field label="Lessee Company" [name]="requestService.selectedRequest" fxFlex="12em"
            [displayField]="'requestor'" [displayField1]="'company'" [displayField2]="'name'" fxLayout="column"
            class="align-items-center"></logzy-view-data-field>
        <logzy-view-data-field label="Requestor Name" [name]="requestService.selectedRequest"
            [displayField]="'requestor'" fxFlex="12em" [displayField1]="'first_name'" [displayField2]="'last_name'"
            fxLayout="column" class="align-items-center"></logzy-view-data-field>
        <logzy-view-data-field label="Leasing Period" fxFlex="12em" fxLayout="column"
            [name]="getLeasingPeriod(requestService.selectedRequest.requirement)"
            class="align-items-center"></logzy-view-data-field>
        <logzy-view-data-field label="Request Date" [date]="requestService.selectedRequest.request_date" fxFlex="12em"
            fxLayout="column" class="align-items-center"></logzy-view-data-field>
    </ng-container>
    <!-- <div class="updateSave">
        <button mat-raised-button (click)="saveRequestLocation()" class="Save">Save</button>
    </div> -->
</div>

<div fxFlex="100">
    <span class="titleDetails">Activity Details</span>
    <ng-container *ngFor="let item of requirementObj?.requirement; let i = index">
        <logzy-requirement-update-form [getReqData]="item" *ngIf="i == 0"></logzy-requirement-update-form>
    </ng-container>
</div>

<div fxFlex="100">
    <span class="titleDetails">Other Details</span>
    <logzy-request-update-form [getReqData]="requestUpdate" (close)="closeView()"></logzy-request-update-form>
</div>